export enum Role {
	CC4AllAdmin = "CC4AllAdmin",
	WebAdmin = "WebAdmin",
	Supervisor = "Supervisor",
	AgentPlus = "AgentPlus",
}

export enum Permission {
	All = "all",
	Generic = "generic",
}
